import { ActionIcon, Group, Kbd, Stack, Tooltip } from '@mantine/core';
import { Icon3dCubeSphere, IconArrowsMaximize } from '@tabler/icons-react';

interface CameraControlsProps {
  onResetCamera: () => void;
  onTopDownView: () => void;
}

export default function CameraControls({ onResetCamera, onTopDownView }: CameraControlsProps) {
  return (
    <Stack gap="xs">
      <Tooltip
        label={
          <Group gap={4}>
            Reset Camera <Kbd size="xs">R</Kbd>
          </Group>
        }
        position="left"
        styles={{
          tooltip: {
            backgroundColor: 'var(--mantine-color-dark-7)',
            border: '1px solid var(--mantine-color-dark-4)',
            color: 'var(--mantine-color-white)',
          },
        }}
      >
        <ActionIcon
          variant="gradient"
          gradient={{ from: 'violet', to: 'blue', deg: 135 }}
          size="lg"
          radius="md"
          onClick={onResetCamera}
          aria-label="Reset Camera (R)"
        >
          <Icon3dCubeSphere size={20} />
        </ActionIcon>
      </Tooltip>
      <Tooltip
        label={
          <Group gap={4}>
            Top-down View <Kbd size="xs">T</Kbd>
          </Group>
        }
        position="left"
        styles={{
          tooltip: {
            backgroundColor: 'var(--mantine-color-dark-7)',
            border: '1px solid var(--mantine-color-dark-4)',
            color: 'var(--mantine-color-white)',
          },
        }}
      >
        <ActionIcon
          variant="gradient"
          gradient={{ from: 'violet', to: 'blue', deg: 135 }}
          size="lg"
          radius="md"
          onClick={onTopDownView}
          aria-label="Top-down View (T)"
        >
          <IconArrowsMaximize size={20} />
        </ActionIcon>
      </Tooltip>
    </Stack>
  );
}
